import { useTranslation } from 'react-i18next';
import { Link, useRouteError } from 'react-router';

import { env } from '@/shared/config/env';
import { ErrorState } from '@/shared/ui';

import styles from './RouteErrorPage.module.css';

/**
 * Global error boundary for routes (render errors, lazy-load failures).
 * Expected API errors should be handled where the data is used (`ErrorState`);
 * this page is the last line of defense.
 */
export function RouteErrorPage() {
  const { t } = useTranslation();
  const error = useRouteError();
  if (env.isDev) console.error(error);
  return (
    <main className={styles.page}>
      <h1>{t('routeError.title')}</h1>
      <ErrorState error={error} />
      <Link to="/">{t('common.backHome')}</Link>
    </main>
  );
}
